
// Constante pour stocké les données
import { createContext } from 'react';

export const UidContext = createContext();

